import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { addDisplayName } from "../Infra/display-name";
import { LoadingPlaceholder } from "./LoadingPlaceholder";
import { ClearIAL2LoginViewModel } from "./ClearIAL2LoginViewModel";
import { useViewModel } from "./useViewModel";
import { useEffect, useRef } from "react";
export const ClearIAL2LoginView = observer((props) => {
    const model = useViewModel(ClearIAL2LoginViewModel, props.container);
    const hasInitialized = useRef(false);
    useEffect(() => {
        if (hasInitialized.current) {
            return;
        }
        hasInitialized.current = true;
        model.loginUsingClearCode();
    }, [model]);
    return _jsx(LoadingPlaceholder, { w: 10, h: 60 });
});
addDisplayName(ClearIAL2LoginView, "ClearIAL2LoginView");
